import type { UserDevice } from '@tunein/web-api-client';
import { createStore } from 'zustand/vanilla';

export interface UserState {
  devices: UserDevice[];
}

export interface UserActions {
  setDevices: (devices: UserDevice[]) => void;
  addDevice: (device: UserDevice) => void;
  removeDevice: (deviceId: number) => void;
}

export type UserStore = UserState & UserActions;
export type InitialUserState = Partial<UserState>;

const defaultState: UserState = {
  devices: [],
};

/** The fields serialized into the page. */
export const userStateKeys = Object.keys(defaultState) as (keyof UserState)[];

export function createUserStore(initialState: InitialUserState = {}) {
  return createStore<UserStore>()((set) => ({
    ...defaultState,
    ...initialState,

    setDevices: (devices) => set({ devices }),
    addDevice: (device) => set((state) => ({ devices: [...state.devices, device] })),
    removeDevice: (deviceId) =>
      set((state) => ({
        devices: state.devices.filter((device) => device.id !== deviceId),
      })),
  }));
}
